import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { DELETE_TRANSACTION } from "../../redux/reducers/transactionReducer";

export function DeleteTransactionModal() {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const transaction = useSelector(
    (state: any) => state.transaction.transaction
  );
  const currentUser = useSelector((state: any) => state.session.currentUser);
  const extendedCard = useSelector((state: any) => state.card.extendedCard);
  const cardTypes = useSelector((state: any) => state.cardTypes.cardTypes);
  const carePrincipal = useSelector(
    (state: any) => state.session.selectedCarePrincipal
  );

  let cardType = cardTypes.find((o: any) => o.id === extendedCard.cardType.id);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onSubmit = (values: any) => {
    const deleteTransaction = {
      actorId: currentUser.id,
      actorName: currentUser.name,
      carePrincipalId: carePrincipal.id,
      transactionId: transaction.transactionId,
      reason: values.reason,
      personId: transaction.personId,
      cardSystemId: extendedCard.cardSystemId,
    };
    dispatch({ type: DELETE_TRANSACTION, deleteTransaction, cardType });
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={1} sx={{ padding: "15px", maxWidth: "40rem" }}>
          <DialogTitle sx={{ padding: "3px 3px" }} id="alert-dialog-title">
            {t("searchCard.manageTxns.deleteTxn")}
          </DialogTitle>
          <DialogContent sx={{ padding: "15px 3px" }}>
            <DialogContentText>
              {t("searchCard.manageTxns.confirmDelete")}
            </DialogContentText>
          </DialogContent>
          <Controller
            name="reason"
            control={control}
            render={() => (
              <TextField
                id="reason"
                error={errors.reason ? true : false}
                size="small"
                label={t("searchCard.manageTxns.deleteReason")}
                {...register("reason")}
              />
            )}
          />
        </Stack>

        <DialogActions sx={{ padding: "0px 15px 10px 0px" }}>
          <Button
            variant="contained"
            onClick={() => dispatch({ type: "MODAL_CANCEL" })}
          >
            {t("cancel")}
          </Button>
          <Button variant="contained" color="error" type="submit" autoFocus>
            {t("remove")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
